import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IonicComponentsModule } from "src/components/ionic-components.module";

/**
 * Message shown in place of an empty list: icon in a light circle, a title, an optional
 * description and, projected inside, an optional action (e.g. an "Add" button).
 *
 * Usage:
 *   <app-empty-state icon="document-outline" [title]="'dictionary.noItemsFound' | translate">
 *     <ion-button (click)="onClickAdd()">...</ion-button>
 *   </app-empty-state>
 */
@Component({
  selector: "app-empty-state",
  templateUrl: "./empty-state.component.html",
  styleUrls: ["./empty-state.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [IonicComponentsModule],
})
export class EmptyStateComponent {
  /** Ionicons name of the icon in the circle */
  @Input() icon: string = "file-tray-outline";
  /** Main message (already translated) */
  @Input() title: string = "";
  /** Optional second line (already translated) */
  @Input() description: string = "";
  /** Without the dashed frame, for empty states inside a card or a popup */
  @Input() plain: boolean = false;
}
